/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import Button from "../GlobalComponents/Button";
import GymOverlayBg from "../Image/gymOverlayBg.jpg";

const Member = ({ text }) => (
  <section css={styles} className="member">
    <h2>
      DON’T <span>THINK</span>, BOOK <span>NOW</span>!
    </h2>
    <p>
      We are providing you best service in Kakadev Kanpur,
      <br /> Hygenic and peaceful enviroment.
    </p>
    <Button text="Contact Now" />
  </section>
);

const styles = css`
  width: 100%;
  padding: 20px 0;
  text-align: center;
  background:linear-gradient(
          rgba(0.0, 0.7, 0.8, 0.9), 
          rgba(0.0, 0.9, 0.1, 0.7)
        ), url('${GymOverlayBg}') no-repeat center/cover;
  h2 {
    color: #fff;
    font-weight: 900;
    font-size: 30px;
    letter-spacing: 1.3px;
    line-height: 1;
    span {
      color: #ed563b;
    }
  }
  p {
    color: #fff;
    font-size: 16px;
    line-height: 1.7;
    margin: 10px 0;
  }
  @media(max-width: 850px) {
    h2{
      font-size: 20px;
    }
    p{
      padding: 0 10px;
      br{
        display: none;
      }
    }
  }
`;

export default Member;
